import React from 'react';
import Routes from './routes';
import { LoaderProvider } from './hooks/LoaderContext';
import {Loader} from './components/root/loader/Loader';

function App() {
  return (
      <LoaderProvider>
          <Loader /> {/* Display the Loader component globally when loading is true */}
        <Routes />
      </LoaderProvider>
  );
}

export default App;